import { ArrowRight } from "lucide-react";

// Property images from portfolio
const TERRACE_EXTERIOR = "https://customer-assets.emergentagent.com/job_property-counsel-1/artifacts/wdhp2po2_d4c3354e-dc04-41b5-8fb2-cd8b672d1b23%202.JPG";
const LUXURY_INTERIOR_1 = "https://customer-assets.emergentagent.com/job_property-counsel-1/artifacts/tlzt11wx_IMG_1471.png";
const LUXURY_INTERIOR_2 = "https://customer-assets.emergentagent.com/job_property-counsel-1/artifacts/6mu1nlen_image.png";
const INTERNATIONAL_TOWERS = "https://images.pexels.com/photos/30052457/pexels-photo-30052457.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260";

const transactions = [
  {
    id: 1,
    image: TERRACE_EXTERIOR,
    title: "Premium Residential Development",
    description: "Comprehensive due diligence and title verification for a multi-unit residential property acquisition."
  },
  {
    id: 2,
    image: LUXURY_INTERIOR_1,
    title: "Luxury Residential Transaction",
    description: "End-to-end legal advisory and transaction coordination for a high-value residential property acquisition."
  },
  {
    id: 3,
    image: LUXURY_INTERIOR_2,
    title: "Executive Residential Transaction",
    description: "Due diligence and closing coordination for a high-value residential property acquisition."
  },
  {
    id: 4,
    image: INTERNATIONAL_TOWERS,
    title: "International Property Advisory",
    description: "International investment structuring and advisory support for a diaspora property acquisition."
  }
];

export const RecentTransactions = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="recent-transactions"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-8 md:mb-12">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Our Portfolio
          </span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-white mt-4 md:mt-6 mb-4 md:mb-6 leading-tight">
            Selected Transactions
            <span className="block text-[#D4AF37] italic">&amp; Advisory Experience</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mb-6 md:mb-8" />
        </div>
        
        {/* Introduction Text */}
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16 lg:mb-20">
          <p className="text-white/60 text-sm md:text-base lg:text-lg leading-[1.8] px-2">
            Since 2020, 4 ACES Attorneys has advised on selected residential property transactions 
            and investment acquisitions, supporting clients with structured due diligence, investor 
            advisory, and transaction coordination.
          </p>
        </div>

        {/* Transactions Grid - Mobile First */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 lg:gap-8">
          {/* Card 1 */}
          <div className="md:col-span-2 lg:col-span-1 group" data-testid="transaction-1">
            <div className="relative overflow-hidden h-[280px] md:h-[350px] lg:h-[420px]">
              <img
                src={transactions[0].image}
                alt={transactions[0].title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/30 to-transparent" />
              
              {/* Content overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 lg:p-8">
                <h3 className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl text-white mb-2 md:mb-3">
                  {transactions[0].title}
                </h3>
                <p className="text-white/60 text-sm md:text-base leading-relaxed">
                  {transactions[0].description}
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group" data-testid="transaction-2">
            <div className="relative overflow-hidden h-[280px] md:h-[350px] lg:h-[420px]">
              <img
                src={transactions[1].image}
                alt={transactions[1].title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/30 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 lg:p-8">
                <h3 className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl text-white mb-2 md:mb-3">
                  {transactions[1].title}
                </h3>
                <p className="text-white/60 text-sm md:text-base leading-relaxed">
                  {transactions[1].description}
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group" data-testid="transaction-3">
            <div className="relative overflow-hidden h-[280px] md:h-[350px] lg:h-[420px]">
              <img
                src={transactions[2].image}
                alt={transactions[2].title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/30 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 lg:p-8">
                <h3 className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl text-white mb-2 md:mb-3">
                  {transactions[2].title}
                </h3>
                <p className="text-white/60 text-sm md:text-base leading-relaxed">
                  {transactions[2].description}
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="md:col-span-2 lg:col-span-1 group" data-testid="transaction-4">
            <div className="relative overflow-hidden h-[280px] md:h-[350px] lg:h-[420px]">
              <img
                src={transactions[3].image}
                alt={transactions[3].title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-[#0A0A0B]/30 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 lg:p-8">
                <h3 className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl text-white mb-2 md:mb-3">
                  {transactions[3].title}
                </h3>
                <p className="text-white/60 text-sm md:text-base leading-relaxed">
                  {transactions[3].description}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12 md:mt-16 pt-10 md:pt-16 border-t border-white/10">
          <p className="text-white/40 text-sm mb-4 md:mb-6">
            Interested in our advisory services?
          </p>
          <a
            href="#booking"
            className="group inline-flex items-center gap-2 md:gap-3 text-[#D4AF37] font-semibold tracking-wide uppercase text-sm md:text-base hover:gap-4 transition-all"
          >
            Discuss Your Project
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};
